import { styled } from '@linaria/react';

const textSizes = {
	small: {
		fz: 14,
		lh: 18,
	},
	medium: {
		fz: 16,
		lh: 20,
	},
	large: {
		fz: 18,
		lh: 24,
	},
};

export const Button = styled.button<{
	size: 'small' | 'medium' | 'large';
	weight?: number;
	transparent?: boolean;
	brandColor?: boolean;
	underline?: boolean;
}>`
	color: ${({ transparent, brandColor }) =>
		brandColor
			? 'var(--brand-pink-light)'
			: transparent
			? 'var(--color-white-06)'
			: 'var(--color-white)'};
	font-size: ${({ size }) => textSizes[size].fz}px;
	font-weight: ${({ weight }) => weight || 400};
	line-height: ${({ size }) => textSizes[size].lh}px;
	text-decoration: ${({ underline }) => (underline ? 'underline' : 'auto')};

	&[disabled] {
		pointer-events: none;
	}

	@media (pointer: fine) {
		&:hover {
			color: var(--color-white);
			text-decoration: underline;
		}
	}
`;
